module.exports = flarum.reg.get('core', 'common/states/PaginatedListState');